/* tslint:disable */
/* eslint-disable */
/**
 * Module Format Contest 
 * Api Format Contest
 *
 * OpenAPI spec version: v1.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * 
 * @export
 * @interface PdaAttributeMetaInfoResponse
 */
export interface PdaAttributeMetaInfoResponse {
    /**
     * 
     * @type {string}
     * @memberof PdaAttributeMetaInfoResponse
     */
    logicId?: string;
    /**
     * 
     * @type {string}
     * @memberof PdaAttributeMetaInfoResponse
     */
    script?: string;
    /**
     * 
     * @type {string}
     * @memberof PdaAttributeMetaInfoResponse
     */
    configuration?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PdaAttributeMetaInfoResponse
     */
    mandatory?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PdaAttributeMetaInfoResponse
     */
    mnemonicCode?: string;
    /**
     * 
     * @type {string}
     * @memberof PdaAttributeMetaInfoResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PdaAttributeMetaInfoResponse
     */
    attributeType?: PdaAttributeMetaInfoResponseAttributeTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PdaAttributeMetaInfoResponse
     */
    visibleToFrontEnd?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PdaAttributeMetaInfoResponse
     */
    confirmed?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum PdaAttributeMetaInfoResponseAttributeTypeEnum {
    JDATE = 'JDATE',
    INVITATIONCODE = 'INVITATION_CODE',
    JNUMBER = 'JNUMBER',
    GENDER = 'GENDER',
    JFILE = 'JFILE',
    JTEXT = 'JTEXT',
    JMULTITEXT = 'JMULTI_TEXT',
    MAIL = 'MAIL',
    PHONE = 'PHONE',
    ADDRESS = 'ADDRESS',
    PLACE = 'PLACE',
    CUSTOM = 'CUSTOM',
    PRIVACY = 'PRIVACY',
    INVITATION = 'INVITATION',
    PASSWORD = 'PASSWORD',
    NUMBERSRANGE = 'NUMBERS_RANGE',
    DATESRANGE = 'DATES_RANGE',
    ATTRIBUTELIST = 'ATTRIBUTE_LIST',
    UNIQUEID = 'UNIQUE_ID'
}

